import { Injectable } from "@nestjs/common";
import { LogBookItems } from "../../log-book-items/log-book-items.entity";
import { ContainerLogBook } from "../container-log-book.entity";
import { ContainerLogBookDto } from "../dto/container-log-book.dto";


@Injectable()
export class ContainerLogBookAdapter {
 
  public convertDtoToEntity(containerLogBookdto: ContainerLogBookDto,  isUpdate: boolean = false ): ContainerLogBook {
    console.log(containerLogBookdto);
    console.log(isUpdate);
    const containerLogBook = new ContainerLogBook();
    containerLogBook.containerLogBookId=containerLogBookdto.containerLogBookId;
    containerLogBook.containerNo=containerLogBookdto.containerNo;
    containerLogBook.vehicleNo= containerLogBookdto.vehicleNo;
    containerLogBook.saleOrderId=containerLogBookdto.saleOrderId;
    containerLogBook.loadingStartTime=containerLogBookdto.loadingStartTime;
    containerLogBook.loadingEndTime=containerLogBookdto.loadingEndTime;
    containerLogBook.loadingDate=containerLogBookdto.loadingDate;
    containerLogBook.unitId=containerLogBookdto.unitId;
    containerLogBook.fileName = containerLogBookdto.fileName;
    containerLogBook.filePath = containerLogBookdto.filePath;
    containerLogBook.isActive=containerLogBookdto.isActive==undefined?true:containerLogBookdto.isActive;
    if (isUpdate) {
        containerLogBook.updatedUser = containerLogBook.updatedUser;
    } else {
      const logBookItems: LogBookItems[] = [];
      for (const item of containerLogBookdto.LogBookInfo) {
        const logitem: LogBookItems = new LogBookItems();
        logitem.logBookItemId = item.logBookItemId;
        logitem.saleOrderItemId = item.saleOrderItemId;
        logitem.unitId = containerLogBookdto.unitId;
        logitem.brandId = item.brandId;
        logitem.row = item.row;
        logitem.cartons = item.cartons;
        logitem.isActive=item.isActive==undefined?true:item.isActive;
        logitem.createdUser = containerLogBookdto.createdUser;
        logitem.updatedUser = containerLogBookdto.createdUser;
        logBookItems.push(logitem);
      }
        containerLogBook.isActive = true;
        containerLogBook.createdUser = containerLogBookdto.createdUser;
        containerLogBook.logBookInfo = logBookItems;
    }
   return containerLogBook;
  }
  public convertEntityToDto(containerLogBookObject: ContainerLogBook): ContainerLogBookDto {
    const containerLogBookdto= new ContainerLogBookDto;
    containerLogBookdto.containerLogBookId = containerLogBookObject.containerLogBookId;
    containerLogBookdto.containerNo = containerLogBookObject.containerNo;
    containerLogBookdto.vehicleNo = containerLogBookObject.vehicleNo;
    containerLogBookdto.saleOrderId = containerLogBookObject.saleOrderId;
    containerLogBookdto.loadingDate = containerLogBookObject.loadingDate;
    containerLogBookdto.unitId = containerLogBookObject.unitId;
    containerLogBookdto.loadingStartTime = containerLogBookObject.loadingStartTime;
    containerLogBookdto.loadingEndTime = containerLogBookObject.loadingEndTime;
    containerLogBookdto.fileName = containerLogBookObject.fileName;
    containerLogBookdto.filePath = containerLogBookObject.filePath;
    containerLogBookdto.isActive = containerLogBookObject.isActive;
    containerLogBookdto.createdAt = containerLogBookObject.createdAt;
    containerLogBookdto.updatedAt = containerLogBookObject.updatedAt;
    containerLogBookdto.createdUser = containerLogBookObject.createdUser;
    containerLogBookdto.updatedUser = containerLogBookObject.updatedUser;
    containerLogBookdto.versionFlag = containerLogBookObject.versionFlag;
    containerLogBookdto.LogBookInfo = containerLogBookObject.logBookInfo;
    return containerLogBookdto;
  }
}
